import React, { Component, Fragment } from 'react';
import { BasicLink, HeaderLink } from './styles';

interface IProps {
  type?: string;
  text: string;
  to: string;
  exact?: boolean;
  disabled?: boolean;
  className?: string;
}
class LinkStyle extends Component<IProps> {
  render() {
    const { type, text, to, ...rest } = this.props;
    if (type === 'header') {
      return (
        <Fragment>
          <HeaderLink to={to} {...rest}>
            {text}
          </HeaderLink>
        </Fragment>
      );
    }
    return (
      <Fragment>
        <BasicLink to={to} {...rest}>
          {text}
        </BasicLink>
      </Fragment>
    );
  }
}

export default LinkStyle;
